import { ProductType } from '@/enums';
import * as Yup from 'yup';
import { INVALID_FIELDS, YupString } from './general';
import { t } from 'i18next';
import { checkOverlap } from '@/pages/authenPages/Product/utils';
import { createSubProductSchema } from './sub-product';

export const createProductSchema = Yup.object().shape({
  name: YupString,
  price: YupString,
  channelId: YupString,
  productType: YupString,
  numberOfKits: Yup.string()
    .nullable()
    .when('productType', {
      is: ProductType.BUNDLE,
      then: fieldSchema => fieldSchema.required(INVALID_FIELDS.REQUIRED),
    }),
  numberOfProbiotics: Yup.string()
    .nullable()
    .when('productType', {
      is: ProductType.BUNDLE,
      then: fieldSchema => fieldSchema.required(INVALID_FIELDS.REQUIRED),
    }),
  probioticType: Yup.string()
    .nullable()
    .when('productType', {
      is: ProductType.PROBIOTIC,
      then: fieldSchema => fieldSchema.required(INVALID_FIELDS.REQUIRED),
    }),
  batch: Yup.number().required(INVALID_FIELDS.REQUIRED),
  quantity: Yup.number().required(INVALID_FIELDS.REQUIRED),
  description: YupString,
  autoTagThirdPartyId: Yup.string()
    .nullable()
    .when('isAutoTagEnabled', {
      is: true,
      then: fieldSchema => fieldSchema.required(INVALID_FIELDS.REQUIRED),
    }),
  subProducts: Yup.array().of(createSubProductSchema),
  priceRange: Yup.array()
    .of(
      Yup.object().shape({
        quantityFrom: Yup.number()
          .required(INVALID_FIELDS.REQUIRED)
          .min(0, ({ min }) => t(INVALID_FIELDS.MIN_NUMBER, { number: min })),
        quantityTo: Yup.number()
          .min(
            Yup.ref('quantityFrom'),
            ({ min }) =>
              min > 0 && t(INVALID_FIELDS.MIN_NUMBER, { number: min }),
          )
          .nullable(),
        price: Yup.number()
          .required(INVALID_FIELDS.REQUIRED)
          .min(0, ({ min }) => t(INVALID_FIELDS.MIN_NUMBER, { number: min })),
      }),
    )
    .test(
      'no-overlapping-ranges',
      INVALID_FIELDS.OVERLAP_PRICE_RANGE,
      function (value) {
        if (!value || value.length < 2) return true; // Skip if empty or single entry
        return !checkOverlap(value);
      },
    )
    .notRequired(),
});

export const updateProductSchema = createProductSchema;

export const updateStockManualSchema = Yup.object().shape({
  quantity: Yup.number().required(INVALID_FIELDS.REQUIRED),
});
